"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDurationTime = void 0;
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../../constants");
const getDurationTime = ({ startDate, endDate, unit = constants_1.UNIT_OF_TIME.days, }) => {
    const currentDate = new Date();
    const startDateMoment = moment_1.default(startDate || currentDate);
    const endDateMoment = moment_1.default(endDate || currentDate);
    const duration = moment_1.default.duration(endDateMoment.diff(startDateMoment));
    return duration.as(unit);
};
exports.getDurationTime = getDurationTime;
//# sourceMappingURL=getDurationTime.js.map